import {
  infiniteQueryOptions,
  keepPreviousData,
  queryOptions
} from '@tanstack/react-query';

import { ELEMENTS_TESTDRIVES } from '@constants/ElementsLimit';

import API from '@api';
import { withSsrCache } from '../../ssrCache';

export const testDriveByIdQueryOptions = (id: number | string) => {
  const testDriveId = Number(id);

  return queryOptions({
    queryKey: ['testDrive', testDriveId],
    queryFn: () =>
      API.getTestDriveById({ id: testDriveId }).then(
        res => res.getTestDriveById
      )
  });
};

/**
 * Список тест-драйвов /test-drive.
 * Помимо стандартных полей страницы, бэкенд отдаёт счётчики для шапки:
 * totalCount («дегустаций») и allTestDriveTesters («экспертов») — кладём их
 * в страницу дополнительными полями и читаем на странице из pages[0].
 * Сортировка «завершённые в конец» перенесена из TestDrivesList и
 * применяется в рамках каждой страницы.
 */
export const testDrivesInfiniteQueryOptions = (initialPage = 1) => {
  const cacheKey = ['testDrives', 'infinite'];

  return withSsrCache(
    infiniteQueryOptions({
      queryKey: cacheKey,
      queryFn: ({ pageParam }) =>
        API.getTestDrives({
          page: pageParam,
          setLimit: ELEMENTS_TESTDRIVES
        }).then(res => {
          const testDrivesCount = res.findTestDriveAll.testDrivesCount || 0;
          const totalCountPages = Math.ceil(
            testDrivesCount / ELEMENTS_TESTDRIVES
          );

          const items = (res.findTestDriveAll.testDriveItems || [])
            .slice()
            .sort((a, b) => +(a.completed === 'Y') - +(b.completed === 'N'));

          return {
            items,
            total: testDrivesCount,
            pagination: {
              total: totalCountPages,
              current: pageParam
            },
            // Счётчики для шапки страницы
            totalCount: res.findTestDriveAll.totalCount || 0,
            totalTesters: res.allTestDriveTesters ?? null
          };
        }),
      initialPageParam: initialPage,
      getNextPageParam: (lastPage, _allPages, lastPageParam) =>
        lastPageParam * ELEMENTS_TESTDRIVES < lastPage.total
          ? lastPageParam + 1
          : undefined,
      placeholderData: keepPreviousData
    })
  );
};

/** Число доступных пользователю тест-драйвов (счётчик на главной) */
export const testDrivesCountQueryOptions = () =>
  queryOptions({
    queryKey: ['testDrivesCount'],
    queryFn: () =>
      API.getTestDrivesCount({}).then(res => res.getTestDrivesCount ?? 0),
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000
  });
